export default "__VITE_ASSET__HJJqVQKz__"